/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceId
 */
export interface InstanceId {
}

/**
 * Check if a given object implements the InstanceId interface.
 */
export function instanceOfInstanceId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InstanceIdFromJSON(json: any): InstanceId {
    return InstanceIdFromJSONTyped(json, false);
}

export function InstanceIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceId {
    return json;
}

export function InstanceIdToJSON(value?: InstanceId | null): any {
    return value;
}

